import React, { useState, useEffect } from "react";
import axios from "axios";

const Veh = () => {
  const [vehicles, setVehicles] = useState([]); // Holds vehicle data
  const [loading, setLoading] = useState(false); // Indicates loading state
  const [error, setError] = useState(""); // Holds error messages
  const [selectedDate, setSelectedDate] = useState(""); // Holds the selected date


  const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle empty or undefined dates
  
    const date = new Date(dateString); // Parse the date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
  
    return `${year}-${month}-${day}`; // Format to YYYY-MM-DD
  };

  
  // Set today's date as the default date on component mount
  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0]; // Format to YYYY-MM-DD
    setSelectedDate(formattedDate);
  }, []);

  // Fetch vehicle data from the API
  const fetchData = async () => {
    // if (!selectedDate) {
    //   setError("Please select a date.");
    //   return;
    // }

    setLoading(true);
    setError("");

    try {
      const response = await axios.get(`http://hunza.ecloud12.com/elp/webservice/onthewayvehicles.php?CompanyCode=02`, {
     //   params: { date: selectedDate },
      });
      console.log("Fetched data for date:", response.data);

      if (response.status !== 200) throw new Error("Failed to fetch data");

      setVehicles(response.data); // Updates vehicles state
    } catch (error) {
      setError("Error fetching data: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Insert vehicle data into the database
  const insertDataIntoDB = async () => {
    console.log("Vehicles to insert:", vehicles);

    if (!vehicles.length) {
      setError("No data to insert.");
      return;
    }

    try {
      const response = await axios.post(
        `https://webcore.hunzagroupofindustries.com.pk/api/ElpOnTheWay`, // Ensure this URL is correct
        vehicles
      );

      if (response.status === 200) {
         console.log("response.status:"+response.status)
        //alert("Data inserted successfully!");
      } else {
        throw new Error("Failed to insert data.");
      }
    } catch (error) {
      setError("Error inserting data: " + error.message);
    }
  };

  // Auto-trigger insertDataIntoDB when vehicles are updated
  useEffect(() => {
    if (vehicles.length > 0) {
      console.log("Auto-triggering data insertion:", vehicles);
      insertDataIntoDB();
    }
  }, [vehicles]);

  // Automatically fetch and insert data at regular intervals
  useEffect(() => {
    const fetchAndInsertData = async () => {
      await fetchData(); // Fetches data and updates vehicles
    };

    // Perform initial fetch and insert
    fetchAndInsertData();

    // Set interval to fetch data every 5 minutes
    const intervalId = setInterval(fetchAndInsertData, 15 * 60 * 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [selectedDate]);

  return (
    <div className="">
      <h2 className="text-center mb-4">Vehicle List</h2>

      <div className="mb-4">
        <label htmlFor="date" className="form-label">
          Select Date:
        </label>
        <input
          type="date"
          id="date"
          className="form-control"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          disabled={loading}
        />
        <button
          className="btn btn-primary mt-3"
          onClick={fetchData}
          disabled={loading}
        >
          {loading ? "Loading..." : "Fetch Data"}
        </button>
        <button
          className="btn btn-success mt-3"
          onClick={insertDataIntoDB}
          disabled={loading || vehicles.length === 0}
        >
          Insert Data into DB
        </button>
      </div>

      {error && <p className="text-danger">{error}</p>}

      {vehicles.length > 0 ? (
        <div className=" table table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Reg No.</th>
                <th>Vehicle No.</th>
                <th>Document No.</th>
                <th>LP Code</th>
                <th>LP Name</th>
                <th>Date of Departure</th>
                <th>Time of Departure</th>
                <th>Status</th>
                <th>Company Code</th>
                <th>Company Name</th>
                <th>Contact Person</th>
                <th>Mobile</th>
                <th>Serial Number</th>
                <th>IMEI</th>
                <th>GPS</th>
                <th>Tower ID</th>
              </tr>
            </thead>
            <tbody>
              {vehicles.map((vehicle, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{vehicle["Reg No."]}</td>
                  <td>{vehicle["Vehicle No."]}</td>
                  <td>{vehicle["Document No."]}</td>
                  <td>{vehicle["LP Code"]}</td>
                  <td>{vehicle["LP Name"]}</td>
                  <td>{(vehicle["Date of Departure"])}</td>

                  <td>{vehicle["Time of Departure"]}</td>
                  <td>{vehicle["Status"]}</td>
                  <td>{vehicle["Company Code"]}</td>
                  <td>{vehicle["Company Name"]}</td>

                
                  <td>{vehicle["Contact Person"]}</td>
                  <td>{vehicle["Mobile"]}</td>
                  <td>{vehicle["Serial Number"]}</td>
                  <td>{vehicle["IMEI"]}</td>
                  <td>{vehicle["GPS"]}</td>
                  <td>{vehicle["Tower Id"]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        !loading && <p>No vehicles found</p>
      )}
    </div>
  );
};

export default Veh;
